import { api } from "~/api";
import { defineComponent, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { myPageStore } from "~/store/MyPageStore";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { commonStore } from "~/store/CommonStore";
import { PageID } from "~/extensions/utils/DefineTypes";
const log = Log.create("KaiyakuEntryComplete");
export default defineComponent({
    name: "KaiyakuEntryCompletePage",
    components: {
        BreadcrumbList
    },
    beforeRouteEnter(to, from, next) {
        if (from.name === "kaiyaku-entry-check" || !from.name) {
            next();
            return;
        }
        next(false);
    },
    async setup() {
        const route = useRoute();
        const router = useRouter();
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        const html = ref("");
        const isHasonCheck = Number(route.query.isHasonCheck === "true");
        // 画面名取得
        const pageName = commonStore.pageName(PageID.kaiyakuEntryComplete);
        try {
            let result = await api.taikyo.loadKaiyakuEntryCompleteText();
            html.value = result;
        }
        catch (ex) {
            log.error("setup", ex);
            MsgBox.error(ex.message);
        }
        return {
            html,
            isHasonCheck,
            isMultipleKeiyaku,
            pageName,
            PageID,
            router
        };
    }
});
